import React from 'react'
import PropTypes from 'prop-types'
import styles from './notifications-read-only.module.scss'
import { Link, generatePath } from 'react-router-dom'
import { ROUTES } from '../../routes'
import moment from 'moment'
import cn from 'classnames'
import { getEntityLink } from '../../utilities/routeUtilities'

export default function NotificationsReadOnlyListItem (props) {
  const {
    notification: {
      read,
      message,
      createdAt,
      sendingUser: user,
      receivingUser,
      entityType,
      entityId
    },
    includeLink,
    showReceiver
  } = props

  return (
    <div className={cn('dis-list-item', read ? 'read-notification' : 'unread-notification', styles.readOnlyItem)}>
      <div className={styles.readOnlyContainer}>
        <div className={styles.readOnlyText}>
          {
            includeLink &&
            (
              <Link to={getEntityLink(entityType, entityId)}
                className={styles.readOnlyLink}>
                <i className={cn('material-icons', styles.linkIcon)}>link</i>
              </Link>
            )
          }
          {message}
        </div>

        {showReceiver
          ? (
            <span>
              Sent to&nbsp;
              <Link to={generatePath(ROUTES.teamMember, { id: receivingUser.id })}>
                {receivingUser.firstName} {receivingUser.lastName}
              </Link>
              &nbsp;at&nbsp;
              {moment(createdAt).format('l')} {moment(createdAt).format('LT')}
            </span>
            )
          : (
            <span className=''>By <Link to={`/hauler/team/${user.id}`}>
              {user.firstName} {user.lastName}</Link> at {moment(createdAt).format('l')} {moment(createdAt).format('LT')}
            </span>
            )
        }
      </div>

      <div disabled={read} className={styles.readOnlyContainer}>
        {read
          ? (
            <div className={styles.readOnlyText}>
              <span className=''>Read</span>
              <i className={cn('material-icons', styles.readOnlyIcon)}>check</i>
            </div>
            )
          : (
            <div className={styles.readOnlyText}>
              <span className=''>Unread</span>
              <i className={cn('material-icons', styles.readOnlyIcon)}>markunread</i>
            </div>
            )
        }
      </div>
    </div>
  )
}

NotificationsReadOnlyListItem.propTypes = {
  includeLink: PropTypes.bool,
  notification: PropTypes.shape({
    createdAt: PropTypes.any,
    entityId: PropTypes.number,
    entityType: PropTypes.string,
    message: PropTypes.string,
    read: PropTypes.bool,
    receivingUser: PropTypes.any,
    sendingUser: PropTypes.any
  }),
  showReceiver: PropTypes.bool
}
